export const VISITOR = 'VISITOR';
